module.exports = __webpack_public_path__ + "img/12_15.cfe24fcf.png";